var map = {
	"./devices/android.png": 990,
	"./devices/android@2x.png": 439,
	"./devices/iphone.png": 991,
	"./devices/iphone@2x.png": 440,
	"./fonts/GT-America-Extended-Bold.woff": 992,
	"./fonts/GT-America-Extended-Bold.woff2": 993,
	"./fonts/GTAmerica-Bold.eot": 994,
	"./fonts/GTAmerica-Bold.ttf": 995,
	"./fonts/GTAmerica-Bold.woff": 996,
	"./fonts/GTAmerica-Bold.woff2": 997,
	"./fonts/GTAmerica-ExpandedBlack.eot": 998,
	"./fonts/GTAmerica-ExpandedBlack.ttf": 999,
	"./fonts/GTAmerica-ExpandedBlack.woff": 1000,
	"./fonts/GTAmerica-ExpandedBlack.woff2": 1001,
	"./fonts/GTAmerica-ExpandedRegular.eot": 1002,
	"./fonts/GTAmerica-ExpandedRegular.ttf": 1003,
	"./fonts/GTAmerica-ExpandedRegular.woff": 1004,
	"./fonts/GTAmerica-ExpandedRegular.woff2": 1005,
	"./fonts/GTAmerica-ExtendedBlack.eot": 1006,
	"./fonts/GTAmerica-ExtendedBlack.ttf": 1007,
	"./fonts/GTAmerica-ExtendedBlack.woff": 1008,
	"./fonts/GTAmerica-ExtendedBlack.woff2": 1009,
	"./fonts/GTAmerica-ExtendedRegular.eot": 1010,
	"./fonts/GTAmerica-ExtendedRegular.ttf": 1011,
	"./fonts/GTAmerica-ExtendedRegular.woff": 1012,
	"./fonts/GTAmerica-ExtendedRegular.woff2": 1013,
	"./fonts/GTAmerica-Regular.eot": 1014,
	"./fonts/GTAmerica-Regular.ttf": 1015,
	"./fonts/GTAmerica-Regular.woff": 1016,
	"./fonts/GTAmerica-Regular.woff2": 1017,
	"./icons/android-chrome-192x192.png": 1018,
	"./icons/android-chrome-512x512.png": 1019,
	"./icons/apple-touch-icon.png": 1020,
	"./icons/favicon-16x16.png": 1021,
	"./icons/favicon-32x32.png": 1022,
	"./icons/favicon.ico": 1023,
	"./icons/mstile-144x144.png": 1024,
	"./icons/mstile-150x150.png": 1025,
	"./icons/mstile-310x150.png": 1026,
	"./icons/mstile-310x310.png": 1027,
	"./icons/mstile-70x70.png": 1028,
	"./icons/safari-pinned-tab.svg": 1029,
	"./stores/app-store-en.svg": 435,
	"./stores/app-store-it.svg": 436,
	"./stores/google-play-en.svg": 437,
	"./stores/google-play-it.svg": 438,
	"./taglines/tagline_web_desktop_en.svg": 443,
	"./taglines/tagline_web_desktop_it.svg": 444,
	"./taglines/tagline_web_mobile_en.svg": 441,
	"./taglines/tagline_web_mobile_it.svg": 442,
	"./video/ic_play.svg": 449,
	"./video/ic_video_normal.svg": 453,
	"./video/ic_volume_off.svg": 451,
	"./video/ic_volume_on.svg": 452,
	"./video/play_broken.svg": 450,
	"./video/rewind.svg": 454
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 989;


//////////////////
// WEBPACK FOOTER
// ../src/client/assets .+
// module id = 989
// module chunks = 19